import { graphql } from "gql";

const ADD_ORGANIZATION_FINDING_POLICY = graphql(`
  mutation AddOrganizationFindingPolicy(
    $name: String!
    $organizationName: String!
    $tags: [String]
    $treatmentAcceptance: TreatmentAcceptancePolicy!
  ) {
    addOrganizationFindingPolicy(
      findingName: $name
      organizationName: $organizationName
      tags: $tags
      treatmentAcceptance: $treatmentAcceptance
    ) {
      success
    }
  }
`);

const DEACTIVATE_ORGANIZATION_FINDING_POLICY = graphql(`
  mutation DeactivateOrganizationFindingPolicy(
    $findingPolicyId: ID!
    $organizationName: String!
    $treatmentAcceptance: TreatmentAcceptancePolicy!
  ) {
    deactivateOrganizationFindingPolicy(
      findingPolicyId: $findingPolicyId
      organizationName: $organizationName
      treatmentAcceptance: $treatmentAcceptance
    ) {
      success
    }
  }
`);

const HANDLE_ORGANIZATION_FINDING_POLICY = graphql(`
  mutation handleOrganizationFindingPolicyAcceptance(
    $findingPolicyId: ID!
    $organizationName: String!
    $status: OrganizationFindingPolicy!
    $treatmentAcceptance: TreatmentAcceptancePolicy!
  ) {
    handleOrganizationFindingPolicyAcceptance(
      findingPolicyId: $findingPolicyId
      organizationName: $organizationName
      status: $status
      treatmentAcceptance: $treatmentAcceptance
    ) {
      success
    }
  }
`);

const RESUBMIT_ORGANIZATION_FINDING_POLICY = graphql(`
  mutation SubmitOrganizationFindingPolicy(
    $findingPolicyId: ID!
    $organizationName: String!
  ) {
    submitOrganizationFindingPolicy(
      findingPolicyId: $findingPolicyId
      organizationName: $organizationName
    ) {
      success
    }
  }
`);

const GET_CRITERIA = graphql(`
  query getCriteriaPolicy($after: String!) {
    criteriaConnection(after: $after, first: null) {
      total
      edges {
        cursor
        node {
          findingNumber
          remediationTime
          requirements
          en {
            description
            impact
            recommendation
            threat
            title
          }
          es {
            description
            impact
            recommendation
            threat
            title
          }

          score {
            base {
              attackComplexity
              attackVector
              availability
              confidentiality
              integrity
              privilegesRequired
              scope
              userInteraction
            }
            temporal {
              exploitCodeMaturity
              remediationLevel
              reportConfidence
            }
          }
          scoreV4 {
            base {
              attackComplexity
              attackRequirements
              attackVector
              availabilitySa
              availabilityVa
              confidentialitySc
              confidentialityVc
              integritySi
              integrityVi
              privilegesRequired
              userInteraction
            }
            threat {
              exploitMaturity
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

export {
  ADD_ORGANIZATION_FINDING_POLICY,
  DEACTIVATE_ORGANIZATION_FINDING_POLICY,
  GET_CRITERIA,
  HANDLE_ORGANIZATION_FINDING_POLICY,
  RESUBMIT_ORGANIZATION_FINDING_POLICY,
};
